/**
 * Human-readable elapsed time in Spanish ("Hace 5 min", "Hace 2 h", "Hace 3 d").
 * Shared by the pipeline board cards, the lead table and the lead card list —
 * it used to be duplicated byte-for-byte in the two pages that are now one.
 */
export function timeAgo(iso: string | null): string {
  if (!iso) return "—";
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60_000);
  if (min < 1) return "Ahora";
  if (min < 60) return `Hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `Hace ${h} h`;
  return `Hace ${Math.floor(h / 24)} d`;
}
